
/* injects from baggage-loader */

export const perguntas = [
['A tribo do leste doou <strong>',
' cavalos</strong> para o povo do oeste. Para proteger os cavalos dos ataques de outros animais, eles os colocaram em cercados.',
' Em <strong>1 cercado</strong>, cabem <strong>',
' cavalos</strong>. Quantos cercados serão necessários?'],
['O povo do leste utiliza caixotes para guardar as frutas que serão distribuídas para alimentar as aldeias. Se em <strong>',
' caixotes</strong> há <strong>',
' frutas</strong>, quantas frutas cabem em cada <strong>caixote</strong>?'],
['Para alimentar <strong>',
' cavalos</strong>, são necessárias <strong>',
' caixas</strong> de frutas. Com <strong>',
' caixas</strong> de frutas, quantos cavalos poderão ser alimentados?']
];

export const palavras = [
'cavalos',
'caixas',
'cercados',
'caixotes',
'frutas'
];

import cavalo from "_images/tela-de-desafio/icons/cavalo.png";
import cercado from "_images/tela-de-desafio/icons/cercado.png";

export const elements1 = [
{
	type: "cercado",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 50,
	icon: 'cercado',
	iconMenor: cercado,
	style: {
		width: '80px',
		height: 'auto',
		padding: '2px'
	},
	question: true
},
{
	type: "cavalo",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 4,
	maxValue: 750,
	icon: 'cavalo',
	iconMenor: cavalo,
	style: {
		width: '80px',
		height: 'auto',
		padding: '2px'
	},
	question: false
}];


import caixote from "_images/tela-de-desafio/icons/caixote.png";
import laranja from "_images/tela-de-desafio/icons/fruta.png";
import caixa from "_images/tela-de-desafio/icons/caixa.png";

export const elements2 = [
{
	type: "caixote",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	,
		padding: '0px 60px'
	},
	value: 1,
	minValue: 1,
	maxValue: 8,
	icon: 'caixote',
	iconMenor: caixote,
	rate: 1,
	style: {
		width: '80px',
		height: '120px',
		padding: '2px'
	},
	question: false
},
{
	type: "laranja",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 720,
	icon: 'laranja',
	iconMenor: laranja,
	rate: 5,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: true
}];

export const elements3 = [
{
	type: "cavalo",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 8,
	icon: 'cavalo',
	iconMenor: cavalo,
	rate: 1,
	style: {
		width: '80px',
		height: '120px',
		padding: '2px'
	},
	question: true
},
{
	type: "caixa",
	parentStyle: {
		width: '480px',
		height: '200px',
		'justify-content': 'center'	
	},
	value: 1,
	minValue: 1,
	maxValue: 720,
	icon: 'caixa',
	iconMenor: caixa,
	rate: 5,
	style: {
		width: '80px',
		height: '80px',
		padding: '2px'
	},
	question: false
},
];


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.const.js